/**
 * Russian ruble.
 */
export var RUB = {
  code: 'RUB',
  base: 10,
  exponent: 2
};